import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {reload} from "@khan/urls";

const strings = {
    errorMessage: (
        refreshLink: React.ReactNode,
        issueLink: React.ReactNode,
    ) => (
        <Trans>
            Uh oh, it looks like we ran into an error. You need to {refreshLink}
            . If this problem persists, {issueLink}.
        </Trans>
    ),
} as const;

/**
 * A React component that returns a React node which includes links to reload
 * the page and also direct the user to report an error.
 */
export default function ReportError() {
    const issueUrl = "https://www.khanacademy.org/reportissue?type=Defect";
    const issueLink = <Link href={issueUrl}>{t`tell us`}</Link>;

    const refreshLink = (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid -- TODO: Address a11y error
        <Link href="#" onClick={reload}>
            {t`refresh`}
        </Link>
    );

    return <>{strings.errorMessage(refreshLink, issueLink)}</>;
}
